import wx from "weixin-js-sdk";
import {api_base} from '@/common/Request.js'
let utils = {
	wxreadyflag:false,
    updateWxShareMenu: function (config) {
        let self = this;
        // alert(JSON.stringify(config))
		console.log('old share');
        wx.onMenuShareAppMessage({
            title: config.title, // 分享标题
            desc: config.desc, // 分享描述
            link: config.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: config.imgUrl, // 分享图标
            success: function () {
                // 设置成功
                console.log("wx.onMenuShareAppMessage success");
            }
        });
        wx.onMenuShareTimeline({
            title: config.title, // 分享标题
            link: config.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: config.imgUrl, // 分享图标
            success: function () {
                // 设置成功
                console.log("wx.onMenuShareTimeline success");
            }
        });
		wx.onMenuShareQQ({
		  title: config.title, // 分享标题
		  desc: config.desc, // 分享描述
		  link: config.link, // 分享链接
		  imgUrl: config.imgUrl, // 分享图标
		  success: function () {
		  // 用户确认分享后执行的回调函数
		  },
		  cancel: function () {
		  // 用户取消分享后执行的回调函数
		  }
		});
		
		wx.onMenuShareQZone({
		  title: config.title, // 分享标题
		  desc: config.desc, // 分享描述
		  link: config.link, // 分享链接
		  imgUrl: config.imgUrl, // 分享图标
		  success: function () {
		  // 用户确认分享后执行的回调函数
		  },
		  cancel: function () {
		  // 用户取消分享后执行的回调函数
		  }
		});
		
		
		wx.updateAppMessageShareData({
		    title: config.title, // 分享标题
		    desc: config.desc, // 分享描述
		    link: config.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		    imgUrl: config.imgUrl, // 分享图标
		    success: function () {
		      // 设置成功
			  console.log("update success");
		    }
		  })
		  
		wx.updateTimelineShareData({ 
		    title: config.title, // 分享标题
		    link: config.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		    imgUrl: config.imgUrl, // 分享图标
		    success: function () {
		      // 设置成功
			  console.log("Timeline success");
		    }
		  })
    },
    initWXConfig: function () {
		let self=this;
		api_base.get_jssdk(window.location.href).then(function (response) {

                wx.config({
                    debug: false,
                    appId: response.data.appId,
                    timestamp: response.data.timestamp,
                    nonceStr: response.data.nonceStr,
                    signature: response.data.signature,
                    jsApiList: [
                        // "hideMenuItems",
                        // "showMenuItems",
                        "onMenuShareTimeline",
                        "onMenuShareAppMessage",
                        // "hideAllNonBaseMenuItem",
                        // "showAllNonBaseMenuItem",
						"onMenuShareQQ",
						"onMenuShareQZone",
						"updateAppMessageShareData",
						"updateTimelineShareData"
                    ]
                });
				self.wxreadyflag=true;
               
            })
            .catch(function (error) {
                console.log(error);
            });

    },
	wxready:function(shareconfig){
		let self=this;
		wx.ready(function () {
		    console.log("wxjsapi is ready");
			
			self.updateWxShareMenu(shareconfig);
		});
	},
	isReady:function(){
		return this.wxreadyflag;
	},
	isIOS:function() {
	  let isIphone = navigator.userAgent.includes('iPhone')
	  let isIpad = navigator.userAgent.includes('iPad')
	  console.log("isIOS:",isIphone || isIpad)
	  return isIphone || isIpad
	}
	
	
}
export default utils
